import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { resetUser } from "../features/user/userSlice";
import {
  canAccessPathWithoutOpenAccount,
  isAgentBlockedByAccountStatus,
} from "../utils/accountAccess";

const checkAuth = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return false;
  }

  try {
    let decodedToken = jwtDecode(token || "");
    let currentDate = new Date();

    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      console.log("Token expired.");
      return false;
    }
  } catch (e) {
    console.log("Token not valid. " + e.message);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return false;
  }

  return true;
};

const ProtectedRoute = ({ component, onlyUnAuth = false, routePath = "" }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isAuthenticated = checkAuth();
  const storedUser = localStorage.getItem("user");
  let user = null;

  if (storedUser) {
    try {
      user = JSON.parse(storedUser);
    } catch (e) {
      user = null;
    }
  }

  const roles = Array.isArray(user?.privileges) ? user.privileges : [];

  if (onlyUnAuth && isAuthenticated) {
    const { from } = location.state ?? { from: { pathname: "/panel" } };
    return <Navigate to={from} />;
  }

  if (!onlyUnAuth && !isAuthenticated) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setTimeout(() => {
      dispatch(resetUser());
    });
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (
    !onlyUnAuth &&
    isAuthenticated &&
    isAgentBlockedByAccountStatus(user, roles) &&
    routePath &&
    !canAccessPathWithoutOpenAccount(routePath)
  ) {
    return <Navigate to="/mydata" replace />;
  }

  return component;
};

export default ProtectedRoute;

export const UnAuthRoute = ({ component }) => (
  <ProtectedRoute onlyUnAuth={true} component={component} />
);
